import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import {useMemo, useRef, useState} from "react";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";

const DamageTable = ({data, setData, setForm, disabled = false}) => {
  const [checkAll, setCheckAll] = useState(false);
  const gridApi = useRef(null);


  const DamageCheckboxRenderer = ({ data }) => {

    const handleChange = () => {

      const newChecked = !data.checked;

      setData(prev =>
        prev.map(el =>
          el.id === data.id
            ? { ...el, checked: newChecked }
            : el
        )
      );

      setForm(prev => {

        const damages = Array.isArray(prev.vehicle_damage)
          ? prev.vehicle_damage
          : [];

        return {
          ...prev,
          vehicle_damage: newChecked
            ? [...damages, {...data, checked: newChecked}]
            : damages.filter(el => el.id !== data.id)
        };
      });
    };

    return (
      <div className="flex items-center justify-center h-full">
        <InputCheckbox
          checked={!!data.checked}
          disabled={disabled}
          onChange={handleChange}
        />
      </div>
    );
  };

  const columnDefs = useMemo(() => [
    {headerName: "Solucionada*", field: "checked", flex: 1, minWidth: 110,
      cellRenderer: DamageCheckboxRenderer},
    {headerName: "Modalidade", field: "modality", flex: 2},
    {headerName: "Data/hora", field: "dt_create_formatted", flex: 2},
    {headerName: "Observação", field: "description", flex: 3},
  ], [])

  return(
    <>
      {data.filter(el => !el.checked).length > 0 &&
        <InputCheckbox
          label="Selecionar todos"
          checked={checkAll}
          disabled={disabled}
          onChange={() => {

            const nextValue = !checkAll;
            setCheckAll(nextValue);
            setData(prev =>
              prev.map(el => ({
                ...el,
                checked: nextValue
              }))
            );
            setForm(prev => ({
              ...prev,
              vehicle_damage: nextValue ? [...data] : []
            }));
          }}
        />
      }
      <div className="aggrid-row-pointer">
        <AgGridReact
          getRowId={(params) => params.data.id}
          onGridReady={params => {
            gridApi.current = params.api
          }}
          domLayout="autoHeight"
          rowData={data.filter(el => !el.dontShow)}
          columnDefs={columnDefs}
          animateRows={false}
          suppressCellFocus={true}
          gridOptions={aggridUtils.defaultGridOptions()}
          theme={aggridUtils.generalTheme()}
          onCellValueChanged={(params) => {
            setData(prev =>
              prev.map(row =>
                row.id === params.data.id ? params.data : row
              )
            );
          }}
        />
      </div>
      { data.filter(el => !el.checked).length > 0 &&
        <div className="w-full text-center text-[11px]"><span>*as avarias e vistorias selecionadas serão removidas</span></div>
      }
    </>
  )
}

export default DamageTable;